import CTAHover from '../../components/ui/CTAHover';
import { useTranslation } from 'react-i18next';

const TwoColumnSection = ({ bgColor = 'bg-white' }) => {
  const { t, i18n } = useTranslation();
  return (
    <section className={`py-0 sm:py-24 ${bgColor}`}>
      <div className="w-[75%] gap-32 items-center mx-auto max-w-screen-xl lg:grid lg:grid-cols-2">
        <div>
          <h3 className="text-2xl text-blue-600 font-bold mb-4">{t('pageHome.content.t5')}</h3>
          <h2 className="text-4xl">{t('pageHome.content.t6')}</h2>
          <p className="mt-6 text-base">
            {t('pageHome.content.t7')}
          </p>
          <p className="mt-6 text-base">
            {t('pageHome.content.t8')}
          </p>
          <CTAHover
            className="mt-6"
            text={t('pageHome.content.t9')}
            href="pricing"
            align="left"
            bgColor="bg-blue-600 text-white "
            textColor="text-stone-700 "
            hoverTextColor="text-white"
          />
        </div>
        <div className="mt-16 lg:mt-0 grid grid-cols-2 gap-4">
          <img className="w-full border rounded-lg" src="https://crino-cdn.nyc3.cdn.digitaloceanspaces.com/pages-images/homepage-investor-network.webp" alt="office content 1" />
          <img className="mt-4 w-full border lg:mt-10 rounded-lg" src="https://crino-cdn.nyc3.cdn.digitaloceanspaces.com/pages-images/homepage-office.webp" alt="office content 2" />
        </div>
      </div>
    </section>
  );
};

export default TwoColumnSection;
